<template>
    <div>
        <v-app-bar
                height="90"
                color="#F6F6F6"
                dense
                elevate-on-scroll
                dark>
          <div>
            <v-img src="../../../../assets/svg/logo.svg" alt="logo" class="logo-icon"/>
          </div>
          <v-spacer/>
          <div class="d-flex align-center justify-space-around" style="width: 400px">
            <RegisterApplicant/>
            <v-btn to="/dashboard" text>Applicants Records</v-btn>
          </div>
          <v-spacer/>
          <div>
            <span class="text--black">Hi, {{elderName}}</span>
          </div>
          <v-spacer/>
          <div>
            <v-btn @click="logOut">Log Out </v-btn>
          </div>
<!--            <v-row>-->
<!--                <v-col cols="12" sm="6" md="3" >-->
<!--                    <v-img src="../../../../assets/svg/logo.svg" alt="logo" class="logo-icon"></v-img>-->
<!--                </v-col>-->

<!--&lt;!&ndash;                <v-spacer></v-spacer>&ndash;&gt;-->
<!--                <v-col cols="12" sm="6" md="3" >-->
<!--                    <RegisterApplicant/>-->
<!--&lt;!&ndash;                    <v-list-item href="https://www.semicolon.africa/" target="_blank" class="header-link black&#45;&#45;text">Register an Applicant</v-list-item>&ndash;&gt;-->
<!--                </v-col>-->
<!--&lt;!&ndash;                <router-link to="/dashboard">&ndash;&gt;-->
<!--                <v-col cols="12" sm="6" md="3" >-->
<!--                     <v-list-item to="/dashboard" class="header-link black&#45;&#45;text record pa-0 ">Applicant Records</v-list-item>-->
<!--                </v-col>-->
<!--&lt;!&ndash;                </router-link>&ndash;&gt;-->

<!--                <v-col cols="12" sm="6" md="3" >-->
<!--                    <v-list-item class="header-link black&#45;&#45;text ml-7">Hello, {{elderName}}</v-list-item>-->
<!--&lt;!&ndash;                  <v-toolbar-title >Hello,{{elderName}} </v-toolbar-title>&ndash;&gt;-->
<!--                </v-col>-->

<!--                <v-col cols="12" sm="6" md="3" >-->
<!--                    <v-list-item @click="logOut">Log Out </v-list-item>-->
<!--                </v-col>-->
<!--            </v-row>-->


        </v-app-bar>
    </div>
</template>
<script>
    import RegisterApplicant from "./RegisterApplicant";
    export default {
        name: "ElderHeader",
        components: {RegisterApplicant},
        data(){
            return{
                elderName:''
            }
        },
        methods:{
            logOut(){
                sessionStorage.removeItem('headers')
                sessionStorage.removeItem('elderName')
                window.localStorage.removeItem('vuex');
                this.$router.push('/');
            }
        },
        created() {
            this.elderName = JSON.parse(sessionStorage.getItem('elderName'))
        }

    }
</script>

<style scoped>
    .v-toolbar__title {
        font-family: IBM Plex Sans;
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 20px;
        /*display: flex;*/
        align-items: center;
        text-align: right;
        margin-top: 15px;
        margin-right: 5px;
        letter-spacing: 0.04em;
        padding-left: 0 !important;
        max-width: 50% !important;

        color: #2B1C1C;
    }
    .logo-icon{
        width: 40px !important;
        flex: none!important;
    }
    .box{
        box-shadow: none!important;
        /*cursor: pointer;*/
    }
    .header-link{
        color: black !important;
    }
    a{
        color: black !important;
    }
    .router-link-active a{
        color: black !important;
    }
    .theme--dark.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled){
        color: black !important;
        text-wrap: inherit !important;
        text-decoration: none !important;
        font-family: IBM Plex Sans !important;
        font-style: normal !important;
        font-weight: normal !important;
        font-size: 15px !important;
        cursor: pointer;


    }
    .record{
        margin-right: 10px !important;
    }
    .nav-row{
        /*cursor: pointer !important;*/
    }


    .text--black {
      color: black;
    }

</style>